import tw, { styled } from "twin.macro"

const PreHeader = styled.h4`
  ${tw`text-sm mb-4 xl:text-base text-brand-dark font-thin`}
  &:before {
    content: "";
    ${tw`border-t border-brand-blue w-6 mb-1 block`}
  }
`

export default PreHeader
